import axios from "axios"
import {configManager, Result} from "@zhoujianhui/vip-core"
import registerInfoMapper from "../mapper/registerinfo-mapper"

const registerService = {
    /**
     * 获取图形验证码
     * @returns {Promise<*>}
     */
    async getImgCaptcha() {
        try {
            const response = await axios.get(`${configManager.getConfig().iam.contextPath}/captchas/img`)

            return Result.success("获取图形验证码成功！").data(response.data).build()
        } catch (error) {
            return Result.error(`获取图形验证码失败！具体原因：${error.message}`).build()
        }
    },

    async register(registerInfo) {
        const registerInfoDto = registerInfoMapper.toDto(registerInfo)
        try {
            await axios.post(`${configManager.getConfig().iam.contextPath}/register/username-password`, registerInfoDto)

            return Result.success("注册成功，正在返回登录页...").build()
        } catch (error) {
            return Result.error(`注册失败！具体原因：${error.message}`).build()
        }
    },
}

export default registerService